import { httpGet, httpPost, baseUrl } from './base'
export const testGet = (params = {}) => {
  return httpGet({ url: '', params })
}

export const joinUs = (data) => {
  return httpPost({
    url: `${baseUrl}/user/join_us`,
    data
  })
}

export const getNewsList = (params = {}) => {
  // https://www.ceati.org.cn/news/list?site=zgZbDQmr7lD7P8lV61vR&limit=12
  return httpGet({
    url: `${baseUrl}/news/list`,
    params
  })
}

export const getNewsDetail = (params = {}) => {
  return httpGet({
    url: `${baseUrl}/news/detail`,
    params
  })
}

export const getAdjoinNews = (params = {}) => {
  return httpGet({
    url: `${baseUrl}/news/around`,
    params
  })
}

export const loginApi = {
  login (data) {
    return httpPost({
      url: `${baseUrl}/user/login`,
      data
    })
  },
  forgetPassword (data) {
    return httpPost({
      url: `${baseUrl}/user/retrievePasswd`,
      data
    })
  },
  registerUser (data) {
    return httpPost({
      url: `${baseUrl}/user/register`,
      data
    })
  },
  getCaptcha (params) {
    return httpGet({
      url: `${baseUrl}/user/captcha`,
      params
    })
  }
}
export const User = {
  getUserInfo (params) {
    return httpGet({
      url: `${baseUrl}/user/info`,
      params
    })
  },
  logout () {
    return httpGet({
      url: `${baseUrl}/user/logout`
    })
  },
  confirmActive (params) {
    return httpGet({
      url: `${baseUrl}/user/activate`,
      params
    })
  },
  editUserInfo (data) {
    return httpPost({
      url: `${baseUrl}/user/info`,
      data
    })
  },
  getPackagelist (data) {
    return httpPost({
      url: `${baseUrl}/package/list`,
      data
    })
  },
  // 获取QTDEtab选项卡
  getTabList (params) {
    return httpGet({
      url: `${baseUrl}/api/v1/download/channel`,
      params
    })
  },
  // 获取QTDE下载列表
  getDownList (data) {
    return httpPost({
      url: `${baseUrl}/api/v1/download/list`,
      data

    })
  },
  // QTDE下载打点
  setAddlog (data) {
    return httpPost({
      url: `${baseUrl}/api/v1/download/addlog`,
      data
    })
  }

}
export const union = {
  // 前台成员列表接口
  getMemberList () {
    return httpGet({ url: `${baseUrl}/member/show` })
  },
  // 前台联盟成员logo接口
  getMemberLogo () {
    return httpGet({ url: `${baseUrl}/member/logo-show` })
  }
}
